import { auth } from '../firebase/config';

/**
 * Get the current Firebase user's ID token
 * @returns Promise<string> - The Firebase ID token
 * @throws Error if user is not authenticated
 */
export const getAuthToken = async (): Promise<string> => {
  const currentUser = auth.currentUser;

  if (!currentUser) {
    throw new Error('User not authenticated');
  }

  try {
    // Force refresh to get a valid token
    const token = await currentUser.getIdToken(false);
    return token;
  } catch (error) {
    console.error('Error getting auth token:', error);
    throw new Error('Failed to get authentication token');
  }
};

/**
 * Get HTTP headers with Firebase authentication token
 * @returns Promise<HeadersInit> - Headers object with Authorization header
 */
export const getAuthHeaders = async (): Promise<HeadersInit> => {
  try {
    const token = await getAuthToken();
    return {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
    };
  } catch (error) {
    console.error('Error getting auth headers:', error);
    // Return headers without auth if token fetch fails
    // This allows the request to fail gracefully at the API level
    return {
      'Content-Type': 'application/json',
    };
  }
};
